import type { CalendarServiceState } from './slices';
import { teamsSlice } from './slices';
import type { CalendarServiceOptions } from './types';

import { getOptionsProvider } from '@shared/OptionsProvider';
import { zustandStoreFactory } from '@shared/zustandStoreFactory';

export const {
  Provider: CalendarServiceProvider,
  useStore: useCalendarServiceStore,
  createStore: createCalendarServiceStore,
} = zustandStoreFactory<CalendarServiceState>(teamsSlice, 'CalendarService');

export const { OptionsProvider: CalendarServiceOptionsProvider, useOptions: useCalendarServiceOptions } =
  getOptionsProvider<CalendarServiceOptions>();
